export default __webpack_public_path__ + "static/media/GroupsMobile.4f924e55.svg";